export const LOCALES = ['en', 'sl', 'hr'] as const;

export type Locale = (typeof LOCALES)[number];

export const DEFAULT_LOCALE: Locale = 'en';

/** Endonyms -- each language named in itself, which is what language pickers should do. */
export const LOCALE_LABEL = {
  en: 'English',
  sl: 'Slovenščina',
  hr: 'Hrvatski',
} as const satisfies Record<Locale, string>;

/** Short form for the compact switcher. */
export const LOCALE_SHORT = {
  en: 'EN',
  sl: 'SL',
  hr: 'HR',
} as const satisfies Record<Locale, string>;

export function isLocale(value: string | null | undefined): value is Locale {
  return LOCALES.includes(value as Locale);
}

/**
 * Best match for the browser's preferences.
 *
 * Matches on the primary subtag, so `sl-SI` and `hr-BA` both resolve. Slovenian and
 * Croatian users routinely have region-qualified locales, and an exact-match lookup
 * would silently fall back to English for all of them.
 */
export function detectLocale(languages: readonly string[] = navigator.languages ?? []): Locale {
  for (const tag of languages) {
    const primary = tag.split('-')[0]?.toLowerCase();
    if (isLocale(primary)) return primary;
  }
  return DEFAULT_LOCALE;
}
